export default class ScrollLinksHandler {
	static init() {
		// scroll to hash on load
		window.addEventListener('load', () => {
            if (window.location.hash === '#next') {
                window.location.hash = '';
            }
            // This is a hacky workaround to scroll to the form element on the page
            // This is necessary because the anchor is not directly on the section element
            if (window.location.hash.substr(0, 6) === '#form_') {
                let targetElement = document.querySelector(window.location.hash).closest('section');
                // if the page has a hash menu, we needs extra space for the absolute positioned el
                let extraOffset = document.querySelector('.hash-menu') ? -81 : -15;
                ScrollLinksHandler.scrollToElement(targetElement, extraOffset);
                return;
            }
			ScrollLinksHandler.scrollToLinkHash(window.location);
		});

		ScrollLinksHandler.applyEventListenerOnSelector('a[href*="#"]');
	}

	static applyEventListenerOnSelector(selector) {
		window.addEventListener('click', (e) => {
			const link = e.target.closest(selector);
			if (link && link.hash && link.href.replace(location.href.replace(location.hash, ''), '') === link.hash) {
				e.preventDefault();
				e.stopPropagation();
				ScrollLinksHandler.scrollToLinkHash(link);
			}
		});
	}

	static scrollToLinkHash(link) {
		let targetElement;
		let extraOffset = 0;
		switch (link.hash) {
			case '#next':
				targetElement = link.closest('section').nextElementSibling;
				if(targetElement.classList.contains('neos-contentcollection')) {
					// the link was inside the header, so get the first content element
					targetElement = targetElement.firstElementChild;
				}
				break;
			case '#top':
				targetElement = document.body;
				break;
			default:
				if (link.hash && document.querySelector(link.hash)) {
					targetElement = document.querySelector(link.hash);
				}
				// if the page has a hash menu, we needs extra space for the absolute positioned el
				extraOffset = document.querySelector('.hash-menu') ? -81 : -15;
		}

		ScrollLinksHandler.scrollToElement(targetElement, extraOffset);
	}

	static scrollToElement(element, extraOffset) {
		if (!element) return;
        const header = document.querySelector('.header__inner');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const bodyRect = document.body.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const elementOffsetTop = elementRect.top - bodyRect.top;
		window.scrollTo({
			behavior: 'smooth',
			left: 0,
			top: elementOffsetTop - headerHeight + (extraOffset || 0)
		});
	}
}
